<template>
  <el-dropdown placement="bottom" @command="handleDropdownClick">
        <span class="el-dropdown-link" @mouseover.self="hover" @click="handleClick">
         {{column[7].title}} <i class="el-icon-arrow-right el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" :style="{'left':offsetLeft+'px'}">
          <el-dropdown-item :command="'1'">{{ column[8].title }}</el-dropdown-item>
          <el-dropdown-item :command="'2'">{{ column[9].title }}</el-dropdown-item>
          <el-dropdown-item :command="'3'">{{ column[10].title }}</el-dropdown-item>
<!--          <el-dropdown-item :command="'4'">{{ $t('nav.about.submenu.Honor') }}</el-dropdown-item>-->
<!--          <el-dropdown-item :command="'5'">{{ $t('nav.about.submenu.History') }}</el-dropdown-item>-->
        </el-dropdown-menu>
      </el-dropdown>
</template>

<script>
import { get_column } from '@/util/lang.js'
export default {
  data(){
    return{
      column : '',
      offsetLeft: 0
    }
  },
  methods: {
    get_content() {
      const url = get_column();
      this.$$axios.get(url).then(res => {
        this.column = res.data
        this.title.en = this.column[10].title

      })
    },

    hover(e){
      let element=e.target;
      let actualLeft = element.offsetLeft;
      let current = element.offsetParent;
      while (current !== null){
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
      }
      this.offsetLeft=actualLeft;
    },
    handleClick () {
      this.$router.push({ name: 'about', params: { tid: '1' } })
    },
    handleDropdownClick (tid) {
      // 编程式导航
      /* <router-link :to="{ name: 'news', params: { tid }}">xxx</router-link> */
      this.$router.push({ name: 'about', params: { tid } })
    }
  },
  created() {
    this.get_content()
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-dropdown-link {
  font-weight: 700;
}
.el-dropdown {
  height: 80px;
}
.el-dropdown-link:hover{
  color: #004b94;
}
.el-dropdown-menu{
  width: fit-content;
  border-radius: 0;
  border: 0;
  background-color: rgba(255,255,255,.6);
}
.el-dropdown-menu .el-dropdown-menu__item{
  float: unset;
  font-size: 14px;
  color: #000;
  font-weight: 700;
}
.el-popper[x-placement^=bottom]{
  margin-top: 0;
}
.el-dropdown-link{
  cursor: pointer;
  font-size: 16px;
  color: #000;
  transition: .3s;
  display: flex;
  align-items: center;
  height: 100%;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: transparent;
    color: #004b94;
}
</style>
